module.exports = __webpack_public_path__ + "img/blog-header.1067fb09.png";